export default ({
  PRIVATE: 'private',
  ADMINS: 'admins',
  ALL: 'all',
})
